import Background from '@anm/components/Background';
import Button from '@anm/components/buttons/Button';
import { LinkContext } from '@anm/contexts/LinkContext';
import { useContext, FC } from 'react';

import Wrapper, { FreePlanDescription, FreePlanTitle } from './Wrapper';

type CurrentFreePlanProps = { route: string };

const CurrentFreePlan: FC<CurrentFreePlanProps> = ({ route }) => {
  const { Link } = useContext(LinkContext);
  return (
    <Wrapper>
      <Background variant="yellow-stars">
        <FreePlanTitle>You are currently on a Free plan</FreePlanTitle>
        <FreePlanDescription>
          Achieve more with the plan that suits you best!
        </FreePlanDescription>
        <Link route={route}>
          <Button size="big" variant="yellow">
            Choose Plan
          </Button>
        </Link>
      </Background>
    </Wrapper>
  );
};

export default CurrentFreePlan;
